module.exports = __webpack_public_path__ + "static/media/contract.15f0e084.svg";